export default __webpack_public_path__ + "static/media/databrickslogo.8d18ca90.png";